import { inject, Pipe, PipeTransform } from '@angular/core';
import { AppdataService } from '../service/appdata.service';

@Pipe({
    name: 'getCategoryNameById',
    standalone: false
})
export class GetCategoryNameByIdPipe implements PipeTransform {
    dataServive = inject(AppdataService);

    transform(id: string): string {
        let cName = this.dataServive.streamCategories.getValue()?.find((category: any) => category.id === id)?.name || '';
        return cName ? cName : id;
    }

}

